import AirTable from "./AirTable"

export default  AirTable;



// WEBPACK FOOTER //
// ./src/common/components/AirTable/index.js